<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_3"></a>
<p class="title">WALKING WOUNDED</p>
<p class="titlea">WILLIAM MCILVANNEY</p>
<p class="pub"><img alt="" height="94" src="images/logo.jpg" width="105"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Title.vue?8e111eb2